<div class="wrapper">
  <div id="crChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #crChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>CR graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>